/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
import { Component, OnInit } from '@angular/core';
import { BaseSettingsService } from '../../providers/base-settings.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  public websiteURL: string;
  public baseHREF: string;

  /**
   * Initialize the class
   */
  constructor(private baseProvider: BaseSettingsService) {
    this.websiteURL = this.baseProvider.websiteURL;
    this.baseHREF = this.baseProvider.baseHREF;
  }

  /**
   * On Init Lifecycle Hook
   */
  ngOnInit() { }
}
